import { Icon } from "@material-ui/core";
import { KeyCode } from "Components/Autocomplete/KeyCode";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import * as React from "react";
import styles from "./AreaSearch.scss";

interface IProps {
    placeholder?: string;
    value?: string[];
    className?: string;
    textboxClassName?: string;
    onClearFilter(): void;
    onFilterAreas(filter: string): void;
}

interface IState {
    value?: string[];
}

export class AreaSearch extends React.Component<IProps, IState> {
    private debounceTimeoutId: number;
    private DEBOUNCE_TIMEOUT: number = 500;

    constructor(props: IProps) {
        super(props);

        this.state = {
            value: props.value
        };

        this.clearSelectionEvent = this.clearSelectionEvent.bind(this);
        this.keyDownEvent = this.keyDownEvent.bind(this);
        this.changeEvent = this.changeEvent.bind(this);
    }

    public render() {

        return (
            <div className={`${styles.searchWrapper} ${this.props.className}`}>
                <div className={`${styles.searchbar} ${this.props.textboxClassName}`}>
                    <span className={styles.icon}><MagnifyIcon /></span>
                    {
                        this.props.value && this.props.value.length > 0 &&
                        <div className={styles.chip}>
                            {
                                this.props.value.map((text: string, index: number) => {
                                    const icon = index !== 0 && <Icon key={`icon_${index}`} className={styles.icon}>arrow_right_alt</Icon>;
                                    return [
                                        icon, <span id="spnSelectedAreaChip" key={`label_${index}`}>{text}</span>
                                    ];
                                })
                            }
                            <Icon className={styles.closeIcon} onClick={this.clearSelectionEvent}>close</Icon>
                        </div>
                    }
                    <input id="txtAreaSearch" className={styles.input} placeholder={this.props.placeholder} onKeyDown={this.keyDownEvent} onChange={this.changeEvent} />
                </div>
            </div>
        );
    }

    public clearSelectionEvent(e: React.MouseEvent) {
        if (this.props.onClearFilter) {
            this.props.onClearFilter();
        }
    }

    public keyDownEvent(e: React.KeyboardEvent<HTMLInputElement>) {
        const inputValue = e.currentTarget.value;

        if (e.keyCode === KeyCode.BACKSPACE_KEY_CODE && inputValue.length === 0) {
            if (this.props.onClearFilter) {
                this.props.onClearFilter();
            }
        }
    }

    public changeEvent(e: React.FormEvent<HTMLInputElement>) {
        const inputValue = e.currentTarget.value;
        if (this.debounceTimeoutId) {
            window.clearTimeout(this.debounceTimeoutId);
        }

        const debounceFunction = () => {
            if (this.props.onFilterAreas) {
                this.props.onFilterAreas(inputValue);
            }
        };

        this.debounceTimeoutId = window.setTimeout(debounceFunction.bind(this), this.DEBOUNCE_TIMEOUT);
    }
}


// WEBPACK FOOTER //
// ./src/Components/AreaSelection/AreaSearch/AreaSearch.tsx